module.exports = __webpack_public_path__ + "img/img_banner.fd48f95f.png";